module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContainer"
  }, [_c('router-link', {
    attrs: {
      "to": "/new"
    }
  }, [_vm._v("New Stock")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/newnote"
    }
  }, [_vm._v("New Note")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/design"
    }
  }, [_vm._v("Design Guide")]), _vm._v(" "), _c('p', [_vm._v("update: 08/05/2018 09:35")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-56c9261e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard.vue
// module id = 68
// module chunks = 0